module.exports = __webpack_public_path__ + "static/media/qrcode.1b7af54f.svg";